var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMapStart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.736,
    height: 32.736,
    viewBox: "0 0 32.736 32.736",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6708",
    "data-name": "Group 6708",
    transform: "matrix(0.695, -0.719, 0.719, 0.695, -1205.779, 187.984)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_485",
    "data-name": "Ellipse 485",
    cx: 9,
    cy: 9.5,
    rx: 9,
    ry: 9.5,
    transform: "translate(965 751)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "airplane",
    transform: "translate(960.846 748.349)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6707",
    "data-name": "Group 6707",
    transform: "translate(0.003)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15385",
    "data-name": "Path 15385",
    d: "M11.578,0A11.576,11.576,0,1,0,23.154,11.575,11.576,11.576,0,0,0,11.578,0ZM17.21,7.675l-2.5,2.37,1.587,6.393-.947.947-3.03-4.941-.07-.07L9.131,15.326c-.018.018-.037.031-.055.048l-.1,2.275-3.47-3.47,2.274-.1c.017-.018.03-.038.048-.056l2.951-3.117-.025-.025L5.768,7.807l.947-.947L13.08,8.477l2.4-2.533A1.225,1.225,0,1,1,17.21,7.675Z",
    transform: "translate(-0.003)",
    fill: "#687088"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapStart);
export default __webpack_public_path__ + "static/media/map-start.e48e72cd28f29d89db262197ef660e11.svg";
export { ForwardRef as ReactComponent };